import React from "react";
import "./WelcomeModal.scss";

import WelcomeImg from "static/images/welcome_img.svg"
import UniversalButton from "../../uiComponents/UniversalButton";

const WelcomeModal = ({
  onActionClick,
}) => {
  return (
    <div className="welcome-modal">
      <img
        className="welcome-modal_img"
        src={WelcomeImg}
      />

      <div
        className="welcome-modal__content"
      >
        <p
          className="welcome-modal__content_title"
        >
          Welcome to BIMSearch!
        </p>

        <p
          className="welcome-modal__content_text"
        >
          Use BIMSearch to instantly pull data from<br /> any Autodesk BIM 360 model: any time, any place.
        </p>

        <p
          className="welcome-modal__content_text"
        >
          Your <span className="welcome-modal__content_text-orange">30-day</span> free trial<br />
          of <span className="welcome-modal__content_text-orange">BIMSearch Premium</span> starts today!
        </p>

        <p
          className="welcome-modal__content_text"
        >
          Take a look at the sample project and see what<br /> BIMSearch has to offer!
        </p>
      </div>

      <div
        className="welcome-modal__button_container"
      >
        <UniversalButton
          label="Let's start!"
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          onClick={onActionClick}
        />
      </div>
      <p
        className="welcome-modal__content_text-note"
      >
        Click the question mark to access the help center or get in touch with us.
      </p>
    </div>
  );
};

export default WelcomeModal;
